module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fhd"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Also by New Academia Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("TURKEY’S MODERNIZATION: Refugees from Nazism and Atatürk’s Vision, by Arnold Reisman")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("DOOMED TO REPEAT? Terrorism and the Lessons of History, Sean Brawley, ed.")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("DETECTING THE BOMB: The Role of Seismology in the Cold War by Carl Romney")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("SHOPPING FOR JESUS: Faith in Marketing in the USA, Dominic Janes, Ed.")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("THE SOVIETIZATION OF EASTERN EUROPE: New Perspectives on the Postwar Period, Balázs Apor, Péter Apor, and E. A. Rees, eds.")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("FROM THE HOLY LAND TO THE NEW JERUSALEM, by Arthur Grenke")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("GOD, GREED, AND GENOCIDE: The Holocaust through the Centuries, by Arthur Grenke")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("NATIONALISM, HISTORIOGRAPHY, AND THE (RE)CONSTRUCTION OF THE PAST, Claire Norton, ed.")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("FROM PIETY TO POLITICS: The Evolution of Sufi Brotherhoods, by Barbara DeGorge")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("SLAVIC THINKERS OR THE CREATION OF POLITIES: Intellectual History and Political Thought in Central Europe and the Balkans in the 19th Century, by Josette Baer")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("ASPECTS OF BALKAN CULTURE: Social, Political, and Literary Perceptions, by Jelena Milojković-Djurić")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("DANGER ZONES: A Diplomat’s Fight for America’s Interests, by John Gunther Dean")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("WITNESS TO A CHANGING WORLD, by David D. Newsom")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("AN ARCHITECT OF DEMOCRACY: Building a Mosaic of Peace, by James Robert Huntley")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("BUSHELS AND BALES: A Food Soldier in the Cold War, by Howard L. Steele")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("NINE LIVES: A Foreign Service Odyssey, by Allen C. Hansen")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("ECHOES OF A DISTANT CLARION, by John G. Kormann")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("PETER STRICKLAND: New London Shipmaster, Boston Merchant, First Consul to Senegal, by Stephen H. Grant")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1da5dee4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_adcard.vue
// module id = 60
// module chunks = 0